<template>
  <b-form @submit.prevent="onSubmit">
    <b-form-row>

      <b-col md="6">
        <b-form-group label="Nombre:">
          <b-form-input name="name" id="name" v-model="$v.name.$model" :state="validateField($v.name)"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group label="Apellido:">
          <b-form-input name="surname" id="surname" v-model="$v.surname.$model" :state="validateField($v.surname)"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group label="Correo electrónico:">
          <b-form-input name="email" id="email" v-model="$v.email.$model" :state="validateField($v.email)"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="8">
        <b-form-group label="Nombre de usuario:">
          <b-form-input name="user_name" id="user_name" v-model="$v.userName.$model" :state="validateField($v.userName)"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Perfil:">
          <b-form-select v-model="$v.profile.$model" :state="validateField($v.profile)" :options="profiles"></b-form-select>
        </b-form-group>
      </b-col>
      
      <b-col md="6" v-if="!user">
        <b-form-group label="Contrasena:">
          <b-form-input type="password" name="password" id="password" v-model="$v.password.$model" :state="validateField($v.password)"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="6" v-if="!user">
        <b-form-group label="Confirmar contraseña:">
          <b-form-input type="password" name="password-confirm" id="password-confirm" v-model="$v.passwordConfirm.$model" :state="validateField($v.passwordConfirm)"></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="12" class="text-right">
        <b-button variant="ow-primary"
          :disabled="saving"
          type="submit"
        >
          Guardar
        </b-button>
      </b-col>
      
    </b-form-row>
  </b-form>
</template>

<script>
import { required, requiredIf, email } from "vuelidate/lib/validators";

export default {
  props: {
    user: {
      type: Object,
      default: () => null
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      surname: '',
      email: '',
      userName: '',
      profile: null,
      password: '',
      passwordConfirm: '',
      profiles: [
        {
          value: null,
          text: 'Elija un perfil',
        },
        {
          value: 'consultant',
          text: 'Consultor'
        },
        {
          value: 'human_resources_executive',
          text: 'Ejecutivo de R. H.'
        },
        {
          value: 'human_resources_manager',
          text: 'Gerente de R. H.'
        },
        {
          value: 'business_analyst',
          text: 'Analista de negocios'
        },
        {
          value: 'payroll_executive',
          text: 'Ejecutivo de nóminas'
        },
        {
          value: 'payroll_manager',
          text: 'Gerente de nóminas'
        },
        {
          value: 'payroll_chief',
          text: 'Directivo de nóminas'
        },
        {
          value: 'sysadmin',
          text: 'Administrador de sistema'
        },
        {
          value: 'audit_manager',
          text: 'Gerente de auditoria'
        },
        {
          value: 'benefit_capturer',
          text: 'Capturista de inicidencias'
        }
      ]
    }
  },
  validations: {
    name: { required },
    surname: { required },
    email: { required, email },
    userName: { required },
    profile: { required },
    password: { required: requiredIf(function() { return this.user == null }) },
    passwordConfirm: {
      required: requiredIf(function() { return this.user == null }),
      sameAsPassword(value) {
        return value === this.password
      }
    }
  },
  mounted() {
    
  },
  methods: {
    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
          return;
      }

      this.$emit('save', {
        'name': this.name,
        'surname': this.surname,
        'email': this.email,
        'user_name': this.userName,
        'profile': this.profile,
        'password': this.password,
        'password_confirmation': this.passwordConfirm
      });
    },
  },
  watch: {
    user: {
      immediate: true,
      handler(u) {
        console.log('u', u)
        if (u) {
          this.name = u.name
          this.surname = u.surname
          this.email = u.email
          this.userName = u.user_name
          this.profile = u.profile
        }
      }
    }
  }
}
</script>
